/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Select, Col, Row } from 'antd';
import Enums from 'utils/EnumsManager';
import { getThemeByType } from 'utils/common';
import { Panel, Section } from 'components/ui/index';
import { FilterCriteria__REFACTORED } from 'components/page/index';
import { FieldsSelection } from 'components/page/ObjectFilter/components/index';
import ExportAction from './ExportAction';
import styles from '../index.less';
import { tryFetchColumns, exportData, changeObject } from '../flow/actions';

const cx = classNames.bind(styles);

const { ObjectTypes } = Enums;
const { Leads, Accounts, Opportunities } = ObjectTypes;

const { Option } = Select;

class ObjectExportFilter extends React.Component {
  componentDidMount() {
    const { dispatchFetchColumns, objectType } = this.props;
    dispatchFetchColumns(objectType);
  }
  componentWillUnmount() {
    this.props.changeObject(Leads);
  }

  handleCancel = () => this.props.changeObject(Leads);

  handleObjectChange = value => this.props.changeObject(value);

  render() {
    const {
      criteriaAndLogic,
      selectedFields,
      dispatchExportData,
      objectType
    } = this.props;
    const theme = getThemeByType(objectType);

    return (
      <Panel
        panelTitle={<FormattedMessage id="page.ObjectExport.export" />}
      >
        <Section
          title={
            <FormattedMessage id="page.ObjectExport.selectObject">
              {text => <span>1. {text}</span>}
            </FormattedMessage>
          }
        >
          <Row type="flex" justify="center">
            <Col span={6}>
              <Select className="full-width" value={objectType} onChange={this.handleObjectChange}>
                {[Leads, Accounts, Opportunities].map(type => (
                  <Option value={type} key={type}>
                    <FormattedMessage id={`global.properNouns.${type}`} />
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
        </Section>
        <Section
          title={
            <FormattedMessage id="page.ObjectExport.filteredBy">
              {text => <span>2. {text}</span>}
            </FormattedMessage>
          }
        >
          <FilterCriteria__REFACTORED needSearchBar theme={theme} />
        </Section>
        <Section
          title={
            <FormattedMessage id="page.ObjectExport.selectFields">
              {text => <span>3. {text}</span>}
            </FormattedMessage>
          }
        >
          <FieldsSelection
            needSearchBar
            theme={theme}
            NeedRestriction
          />
          <Row className={cx('file-export-actions')} >
            <Col span={4}>
              <ExportAction
                objectType={objectType}
                theme={theme}
                criteriaAndLogic={criteriaAndLogic}
                selectedFields={selectedFields}
                exportData={dispatchExportData}
                handleCancel={this.handleCancel}
              />
            </Col>
          </Row>
        </Section>
      </Panel>
    );
  }
}

const mapStateToProps = ({
  FilterCriteria__REFACTORED: filterCriteria,
  global,
  objectView,
  setup
}) => ({
  criteriaAndLogic: filterCriteria,
  lang: global.language,
  selectedFields: objectView.fields.selectedFields,
  objectType: setup.fileExport.objectType
});

const mapDispatchToProps = {
  dispatchFetchColumns: tryFetchColumns,
  dispatchExportData: exportData,
  changeObject
};

export default connect(mapStateToProps, mapDispatchToProps)(ObjectExportFilter);



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/component/ObjectExportFilter.jsx